import React from 'react';

function LinkedinLogoIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      className={className}
      viewBox="0 0 22.258 22.258"
    >
      <g>
        <path d="M5.366,2.973c0,1.376-1.035,2.479-2.699,2.479H2.636C1.034,5.453,0,4.348,0,2.973c0-1.409,1.067-2.482,2.698-2.482
        C4.331,0.49,5.336,1.564,5.366,2.973z M0.28,21.766h4.772V7.413H0.28V21.766z M16.764,7.077c-2.531,0-3.664,1.39-4.301,2.37v0.046
        h-0.031c0.012-0.014,0.023-0.03,0.031-0.046V7.414H7.692c0.062,1.345,0,14.353,0,14.353h4.771v-8.016
        c0-0.432,0.029-0.855,0.157-1.164c0.346-0.854,1.132-1.747,2.446-1.747c1.729,0,2.42,1.319,2.42,3.247v7.68h4.771v-8.229
        C22.258,9.126,19.902,7.077,16.764,7.077z"
        />
      </g>
    </svg>
  );
}

export default LinkedinLogoIcon;
